/**
 * Toast notifications provider
 * Configures react-hot-toast with theme support
 */

import { Toaster } from 'react-hot-toast';
import { usePreferencesStore } from '@/stores/usePreferencesStore';

export function ToastProvider() {
  const { theme } = usePreferencesStore();
  const isDarkMode = theme === 'dark';

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: isDarkMode ? '#1f1f1f' : '#fff',
          color: isDarkMode ? '#fff' : '#262626',
          border: `1px solid ${isDarkMode ? '#424242' : '#d9d9d9'}`,
          borderRadius: 8,
          padding: '12px 16px',
          fontSize: 14,
          boxShadow: isDarkMode
            ? '0 6px 16px rgba(0, 0, 0, 0.32)'
            : '0 6px 16px rgba(0, 0, 0, 0.08)',
        },
        success: {
          iconTheme: {
            primary: '#52c41a',
            secondary: '#fff',
          },
        },
        error: {
          iconTheme: {
            primary: '#ff4d4f',
            secondary: '#fff',
          },
          duration: 6000,
        },
        loading: {
          iconTheme: {
            primary: '#1677ff',
            secondary: isDarkMode ? '#1f1f1f' : '#fff',
          },
        },
      }}
      containerStyle={{
        top: 72, // Below header
      }}
      gutter={12}
    />
  );
}

export default ToastProvider;
